import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormattedDate(props) {
  const {
    date,
    now
  } = props;
  const defaultNow = I18n.moment.portalTz();
  const nowDate = now || defaultNow;
  const momentDate = I18n.moment.portalTz(date);
  const isToday = momentDate.isSame(nowDate, 'day');
  if (isToday) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "productApprovals.FormattedDate.todayAtTime_jsx",
      elements: {
        Date: FormattedDateTime
      },
      options: {
        value: momentDate
      }
    });
  }
  const isSameYear = momentDate.isSame(nowDate, 'year');
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "productApprovals.FormattedDate.dateAtTime_jsx",
    elements: {
      Date: FormattedDateTime
    },
    options: {
      dateFormat: isSameYear ? 'short-date' : 'll',
      value: momentDate
    }
  });
}